// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { XngGaCustomVirtualPageViewEvent } from "@ces/App/Handlers/GoogleAnalytics/XngGaCustomVirtualPageViewEvent";
import { CustomAppState } from "@ces/App/Store/Reducers";
import { FulfillmentMethod } from "@ces/XDL/types";
import { addToChainAfter, addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    PopulateApiParameter,
    SendTracking,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import setNotes from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetNotes";

const xPopulateApiParameter: typeof PopulateApiParameter = props => {
    const state = props.getState() as CustomAppState;
    const pickupTime = state.xRequestedPickupTimes.selectedTime;
    const fulfillmentMethod = getSession(props.getState()).properties?.pickUpType;
    const { editedCartNotes } = state.pages.checkoutShipping;

    props.apiParameter.cart.properties = {
        ...(props.apiParameter.cart.properties || {}),
        ...(!!pickupTime && { RequestedPickupTime: pickupTime }),
        ...(!!fulfillmentMethod &&
            props.apiParameter.cart.fulfillmentMethod !== FulfillmentMethod.Ship && { pickUpType: fulfillmentMethod }),
    };
    props.apiParameter.cart.notes =
        typeof editedCartNotes === "undefined" ? props.apiParameter.cart.notes : editedCartNotes;
};

const xResetCheckoutNotes: typeof PopulateApiParameter = props => {
    props.dispatch(setNotes({ notes: "" }));
};

addToChainAfter(chain, PopulateApiParameter, xPopulateApiParameter);
addToChainAfter(chain, SendTracking, XngGaCustomVirtualPageViewEvent);
addToEndOfChain(chain, xResetCheckoutNotes);
